import { Download, Trash2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface BulkActionsBarProps {
  selectedCount: number;
  onClearSelection: () => void;
  onBulkDelete: () => void;
  onBulkExport: () => void;
  isPending?: boolean;
}

export function BulkActionsBar({
  selectedCount,
  onClearSelection,
  onBulkDelete,
  onBulkExport,
  isPending = false,
}: BulkActionsBarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center gap-3 rounded-md border bg-muted/30 px-4 py-3 animate-in slide-in-from-top-2">
      <Badge variant="secondary" className="font-medium">
        {selectedCount} selected
      </Badge>

      <div className="h-4 w-px bg-border" />

      <Button
        size="sm"
        variant="ghost"
        onClick={onBulkExport}
        disabled={isPending}
      >
        <Download className="h-4 w-4 mr-2" />
        Export
      </Button>

      <Button
        size="sm"
        variant="destructive"
        onClick={onBulkDelete}
        disabled={isPending}
      >
        <Trash2 className="h-4 w-4 mr-2" />
        Delete {selectedCount > 1 ? `(${selectedCount})` : ''}
      </Button>

      <div className="flex-1" />

      <Button
        size="sm"
        variant="ghost"
        onClick={onClearSelection}
        disabled={isPending}
      >
        <X className="h-4 w-4 mr-2" />
        Clear
      </Button>
    </div>
  );
}
